import { useCallback, useContext } from 'react';
import { AppContext, ServerEnvs } from '../utils/AppContext';

const envsToEnable = [''];

const shouldInitNewRelic = (envData: ServerEnvs) =>
  envsToEnable.some((env) => envData?.ENV?.includes(env));

const useNewrelic = () => {
  const { envData } = useContext(AppContext);

  const startNewrelic = useCallback(async () => {
    if (envData.ENV) {
      const shouldInit = shouldInitNewRelic(envData);
      if (shouldInit) {
        const newRelicNode = document.createElement('script');
        newRelicNode.type = 'text/javascript';
        newRelicNode.src = './newrelic.js';
        const s = document.getElementsByTagName('script')[0];
        s?.parentNode?.insertBefore(newRelicNode, s);
      }
    }
  }, [envData?.ENV]);

  return {
    startNewrelic,
  };
};

export default useNewrelic;
